module.exports = __webpack_public_path__ + "img/55.cd523b04.jpg";